import styled from 'styled-components'

export const FloatButton = styled.button`
  position: fixed;
  bottom: 16px;
  right: 16px;
  background-color: #25d366;
  color: white;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 1000;

  &:hover {
    background-color: #128c7e;
  }
`
